import sales_icon from './images/sales_icon.png';
import organize_icon from './images/organize_icon.png';
import cleanout_icon from './images/cleanout_icon.png';
import lawncare_icon from './images/lawn_care_icon.png';

import sales_hero from './images/estate_sales.png';
import organize_hero from './images/organize_hero.png';
import cleanout_hero from './images/site_cleanup_hero.png';
import lawncare_hero from './images/lawn_care_hero.png';

const services = [
  {
    id: 'downsizing',
    title: 'Downsizing & Organizing',
    description: 'Clear, sort, and organize household items during major life transitions.',
    longDescription:
      'Our downsizing and organizing service helps you take control during times of change. Whether you are moving, merging households, or managing an estate, we assist with sorting, categorizing, and reducing clutter in a respectful and supportive manner.',
    tasks: [
      'Sort and categorize household items',
      'Declutter and prepare for donation',
      'Organize closets, kitchens, and garages',
      'Pack and label items for storage or moving',
    ],    
    icon: organize_icon,
    heroImage: organize_hero,
    heroAlt: 'Boxes and household items being organized neatly',
    meta: {
      keywords: 'downsizing, organizing, home declutter, sorting, moving help',
    },
    formQuestions: [
      {
        label: "Are you seeking help with downsizing, organizing, or both?",
        name: "serviceFocus",
        type: "text",
        placeholder: "e.g. Downsizing only, Organizing only, Both",
      },
      {
        label: "What type of space are you downsizing?",
        name: "spaceType",
        type: "text",
        placeholder: "e.g. apartment, single-family home, senior living move",
      },
      {
        label: "Approximately how many rooms or areas need organizing?",
        name: "roomCount",
        type: "text",
        placeholder: "e.g. 3 bedrooms, garage, and kitchen",
      },
      {
        label: "Are there sentimental or high-value items that need special care?",
        name: "specialItems",
        type: "textarea",
        placeholder: "e.g. heirlooms, collections, photo albums",
      },
      {
        label: "What is your desired timeframe for completing the project?",
        name: "timeframe",
        type: "text",
        placeholder: "e.g. within 2 weeks, flexible",
      },
      {
        label: "Do you need help designing or setting up any organizing systems?",
        name: "needsOrganizingSystems",
        type: "textarea",
        placeholder: "e.g. pantry bins, closet dividers, storage labels",
      },
      {
        label: "Would you like shelves, hooks, or other hardware installed?",
        name: "shelvingInstall",
        type: "text",
        placeholder: "e.g. Yes, in garage and laundry room",
      },
      {
        label: "Do any areas have unusual storage challenges?",
        name: "storageChallenges",
        type: "textarea",
        placeholder: "e.g. Sloped closet walls, small attic space, deep pantry",
      },
      {
        label: 'Full Name',
        name: 'contactName',
        type: 'text',
        placeholder: 'e.g. Jane Doe',
        required: true,
      },
      {
        label: 'Email Address',
        name: 'contactEmail',
        type: 'email',
        placeholder: 'e.g. jane.doe@example.com',
        required: true,
      },
      {
        label: 'Phone Number',
        name: 'contactPhone',
        type: 'tel',
        placeholder: 'e.g. (512) 555-1234',
        required: true,
      },
      {
        label: 'Service Address',
        name: 'serviceAddress',
        type: 'text',
        placeholder: 'e.g. 123 Main St, Austin, TX',
        required: false,
      },
      {
        label: 'Best Time to Reach You',
        name: 'preferredContactTime',
        type: 'text',
        placeholder: 'e.g. Weekdays after 5pm, Weekends',
        required: false,
      },
      {
        label: 'Additional Notes (optional)',
        name: 'additionalNotes',
        type: 'textarea',
        placeholder: 'Any other details we should know…',
        required: false,
      },
    ]
  },
  {
    id: 'estate-sales',
    title: 'Estate & Moving Sales',
    description: 'Plan, price, and run sales to simplify moves or settle estates.',
    longDescription:
      'We handle every aspect of your estate or moving sale, including pricing, staging, marketing, and conducting the sale itself. Our compassionate team ensures the process is smooth and respectful to families and property.',
    tasks: [
      'Price items for fair market value',
      'Stage home for an inviting sale',
      'Advertise and promote locally',
      'Manage the sale and handle transactions',
    ],
    icon: sales_icon,
    heroImage: sales_hero,
    heroAlt: 'Estate sale items displayed on tables outdoors',
    meta: {
      keywords: 'estate sale, moving sale, pricing items, family support',
    },
    formQuestions: [
      {
        label: "Are you planning an estate sale, moving sale, or garage sale?",
        name: "saleType",
        type: "text",
        placeholder: "e.g. Estate sale, Moving sale, Garage sale",
      },
      {
        label: "What is the approximate size of the estate or property?",
        name: "estateSize",
        type: "text",
        placeholder: "e.g. 3-bedroom home, 2-car garage, backyard",
      },
      {
        label: "Are there any high-value or specialty items?",
        name: "specialItems",
        type: "textarea",
        placeholder: "e.g. antiques, collectibles, jewelry, firearms",
      },
      {
        label: "Do you want to include items from multiple families or households?",
        name: "multiFamily",
        type: "text",
        placeholder: "e.g. Yes, 2 families / No, single household only",
      },
      {
        label: "Are there any items that should not be sold or need special handling?",
        name: "restrictedItems",
        type: "textarea",
        placeholder: "e.g. family heirlooms, legal documents, prescription items",
      },
      {
        label: "What is your preferred timeframe or sale date?",
        name: "preferredDate",
        type: "text",
        placeholder: "e.g. Next weekend, flexible within 30 days",
      },
      {
        label: "Will you need help removing or cleaning up unsold items afterward?",
        name: "postSaleHelp",
        type: "text",
        placeholder: "e.g. Yes, full cleanout / No, I will handle remaining items",
      },
      {
        label: 'Full Name',
        name: 'contactName',
        type: 'text',
        placeholder: 'e.g. Jane Doe',
        required: true,
      },
      {
        label: 'Email Address',
        name: 'contactEmail',
        type: 'email',
        placeholder: 'e.g. jane.doe@example.com',
        required: true,
      },
      {
        label: 'Phone Number',
        name: 'contactPhone',
        type: 'tel',
        placeholder: 'e.g. (512) 555-1234',
        required: true,
      },
      {
        label: 'Service Address',
        name: 'serviceAddress',
        type: 'text',
        placeholder: 'e.g. 123 Main St, Austin, TX',
        required: false,
      },
      {
        label: 'Best Time to Reach You',
        name: 'preferredContactTime',
        type: 'text',
        placeholder: 'e.g. Weekdays after 5pm, Weekends',
        required: false,
      },
      {
        label: 'Additional Notes (optional)',
        name: 'additionalNotes',
        type: 'textarea',
        placeholder: 'Any other details we should know…',
        required: false,
      },
    ],
  },
  {
    id: 'site-cleaning',
    title: 'Site Cleanup',
    description: 'Remove everything and leave the space clean, inside and out.',
    longDescription:
      'After a sale or a move, we ensure your space is thoroughly cleared and cleaned. Whether it’s a garage, attic, entire home, or yard, we take care of every last detail to leave it broom-swept and ready for what’s next.',
    tasks: [
      'Remove remaining items and debris',
      'Clean floors, counters, and surfaces',
      'Dispose of trash or recyclables',
      'Sweep and prepare the site for turnover',
    ],
    icon: cleanout_icon,
    heroImage: cleanout_hero,
    heroAlt: 'Clean empty room after junk removal',
    meta: {
      keywords: 'site cleanup, junk removal, cleanout service, post-sale cleaning, yard cleanup, lawn mowing',
    },
    formQuestions: [
      // --- Site Cleanup Core ---
      {
        label: "What type of site needs to be cleaned?",
        name: "siteType",
        type: "text",
        placeholder: "e.g. house, garage, yard, rental unit, storage unit",
      },
      {
        label: "Is this related to a recent sale, move, or other event?",
        name: "cleanupContext",
        type: "text",
        placeholder: "e.g. After an estate sale / Tenant move-out / Pre-listing cleanup",
      },
      {
        label: "Approximately how much needs to be removed?",
        name: "volumeEstimate",
        type: "text",
        placeholder: "e.g. A few items / Several rooms / Full property",
      },
      {
        label: "Are there any heavy, bulky, or hazardous items?",
        name: "hazardousItems",
        type: "textarea",
        placeholder: "e.g. appliances, mattresses, paint cans, sharp debris",
      },
      {
        label: "Do you need help disposing of any items?",
        name: "disposalNeeded",
        type: "text",
        placeholder: "e.g. Yes, trash and donation / No, just removal",
      },
      {
        label: "Do you need deep cleaning services after item removal?",
        name: "deepCleaning",
        type: "text",
        placeholder: "e.g. Yes, full cleaning / Just sweeping / No cleaning needed",
      },
      {
        label: "Is the site indoors, outdoors, or both?",
        name: "siteLocationType",
        type: "text",
        placeholder: "e.g. Indoors only / Outdoors only / Both",
      },
      {
        label: "Is there easy access for loading items (e.g. driveway, side gate)?",
        name: "accessDetails",
        type: "textarea",
        placeholder: "e.g. Driveway is clear / Upstairs apartment with no elevator",
      },
      {
        label: "What is your desired timeframe for the cleanup?",
        name: "cleanupTimeframe",
        type: "text",
        placeholder: "e.g. ASAP / This weekend / Within 2 weeks",
      },

      // --- Grounds Care Add-on ---
      {
        label: "Would you like outdoor grounds care or mowing included?",
        name: "includeGroundsCare",
        type: "text",
        placeholder: "e.g. Yes, please include lawn and edging",
      },
      {
        label: "What size is the lawn or outdoor area?",
        name: "yardSize",
        type: "text",
        placeholder: "e.g. Small front yard / ¼ acre / Large lot",
      },
      {
        label: "Do you need grass trimming along fences or walkways?",
        name: "trimmingNeeded",
        type: "text",
        placeholder: "e.g. Yes, especially near fence and flower beds",
      },
      {
        label: "Should we remove leaves, branches, or other yard debris?",
        name: "yardDebrisRemoval",
        type: "text",
        placeholder: "e.g. Yes, full cleanup / Just mowing",
      },
      {
        label: "Is this a one-time service or would you like ongoing grounds care?",
        name: "groundsCareFrequency",
        type: "text",
        placeholder: "e.g. One-time / Weekly / Biweekly",
      },
      {
        label: 'Full Name',
        name: 'contactName',
        type: 'text',
        placeholder: 'e.g. Jane Doe',
        required: true,
      },
      {
        label: 'Email Address',
        name: 'contactEmail',
        type: 'email',
        placeholder: 'e.g. jane.doe@example.com',
        required: true,
      },
      {
        label: 'Phone Number',
        name: 'contactPhone',
        type: 'tel',
        placeholder: 'e.g. (512) 555-1234',
        required: true,
      },
      {
        label: 'Service Address',
        name: 'serviceAddress',
        type: 'text',
        placeholder: 'e.g. 123 Main St, Austin, TX',
        required: false,
      },
      {
        label: 'Best Time to Reach You',
        name: 'preferredContactTime',
        type: 'text',
        placeholder: 'e.g. Weekdays after 5pm, Weekends',
        required: false,
      },
      {
        label: 'Additional Notes (optional)',
        name: 'additionalNotes',
        type: 'textarea',
        placeholder: 'Any other details we should know…',
        required: false,
      },
    ]
  },
  {
    id: 'lawn-care',
    title: 'Lawn & Grounds Maintenance',
    description: 'Mow, trim, and maintain outdoor areas with professional care.',
    longDescription:
      'Our lawn care and grounds maintenance service keeps your property looking clean, safe, and inviting. We handle everything from mowing and edging to trimming, debris removal, and seasonal upkeep. Whether you need a one-time cleanup or regular maintenance, we tailor our services to your needs and property size.',
    tasks: [
      'Mow front, back, or full yard',
      'Edge along driveways, sidewalks, and beds',
      'Trim overgrowth and maintain fences and borders',
      'Remove yard debris, branches, or clippings',
      'Provide recurring or one-time service options',
    ],
    icon: lawncare_icon, // Replace with your actual icon
    heroImage: lawncare_hero, // Replace with your actual image
    heroAlt: 'Freshly mowed lawn with neat edges and trimmed greenery',
    meta: {
      keywords: 'lawn care, mowing, yard cleanup, trimming, grounds maintenance, outdoor service',
    },
    formQuestions: [
      {
        label: "What kind of lawn care services do you need?",
        name: "lawnServicesNeeded",
        type: "text",
        placeholder: "e.g. Mowing and trimming / Full yard cleanup / Regular care",
      },
      {
        label: "Approximately how large is the lawn or outdoor area?",
        name: "yardSize",
        type: "text",
        placeholder: "e.g. Small front yard / ¼ acre / Large lot",
      },
      {
        label: "Do you need edging along sidewalks, beds, or fences?",
        name: "edgingNeeded",
        type: "text",
        placeholder: "e.g. Yes, especially around flower beds / No",
      },
      {
        label: "Do you need help trimming bushes, vines, or other overgrowth?",
        name: "overgrowthTrimming",
        type: "text",
        placeholder: "e.g. Yes, front bushes / No trimming needed",
      },
      {
        label: "Should we remove grass clippings, leaves, or yard debris?",
        name: "debrisRemoval",
        type: "text",
        placeholder: "e.g. Yes, bag and haul away / No, leave clippings on lawn",
      },
      {
        label: "Is this a one-time job or do you want recurring service?",
        name: "serviceFrequency",
        type: "text",
        placeholder: "e.g. One-time / Weekly / Biweekly / Monthly",
      },
      {
        label: "Do you have any fencing, gates, or pets we should be aware of?",
        name: "accessOrPets",
        type: "textarea",
        placeholder: "e.g. Locked gate in back / Dog on property",
      },
      {
        label: "When would you like this service performed?",
        name: "preferredSchedule",
        type: "text",
        placeholder: "e.g. ASAP / Next week / Saturday mornings",
      },
      {
    label: 'Full Name',
    name: 'contactName',
    type: 'text',
    placeholder: 'e.g. Jane Doe',
    required: true,
  },
  {
    label: 'Email Address',
    name: 'contactEmail',
    type: 'email',
    placeholder: 'e.g. jane.doe@example.com',
    required: true,
  },
  {
    label: 'Phone Number',
    name: 'contactPhone',
    type: 'tel',
    placeholder: 'e.g. (512) 555-1234',
    required: true,
  },
  {
    label: 'Service Address',
    name: 'serviceAddress',
    type: 'text',
    placeholder: 'e.g. 123 Main St, Austin, TX',
    required: false,
  },
  {
    label: 'Best Time to Reach You',
    name: 'preferredContactTime',
    type: 'text',
    placeholder: 'e.g. Weekdays after 5pm, Weekends',
    required: false,
  },
  {
    label: 'Additional Notes (optional)',
    name: 'additionalNotes',
    type: 'textarea',
    placeholder: 'Any other details we should know…',
    required: false,
  },
    ]
  }
];

export default services;
